import React from 'react';

import { Panel, PanelHeader, Div } from '@vkontakte/vkui';

//import ScreenSpinner from '@vkontakte/vkui/dist/components/ScreenSpinner/ScreenSpinner';

class Preloader extends React.Component {
	
    componentDidMount = () => {
    }
	
    componentDidUpdate = () => {
    }
	
	render = () => {

        //console.log('props', this.props);

		return (
			<Panel 
				id={this.props.id}
				//separator={false}
			>
				<PanelHeader>
                    { this.props.title }
				</PanelHeader>

                <Div>
                    Preloader...
                </Div>
			</Panel>
		);
	}

}

export default Preloader;
